import React from "react";
import Modal from "../../../library/Modal";

/**
 * Generic confirmation modal (grade lock/unlock, unlink, version assignment, etc.).
 * @param {boolean} open Whether the modal is shown.
 * @param {{title: string, description: string, label: string, icon: string, tone: string}} copy Action copy.
 * @param {Function} onClose Called on Cancel or dismiss.
 * @param {Function} onConfirm Called when the primary action is clicked.
 * @param {number} [width=506] Modal width.
 * @param {boolean} [primaryDisabled=false] Whether the primary action is disabled.
 */
function ConfirmationModal({
    open,
    copy,
    onClose,
    onConfirm,
    width = 506,
    primaryDisabled = false,
}) {
    if (!open || !copy) {
        return null;
    }

    return (
        <Modal
            title={copy.title}
            description={copy.description}
            onClose={onClose}
            width={width}
            primaryAction={{
                label: copy.label,
                icon: copy.icon,
                tone: copy.tone,
                onClick: onConfirm,
                disabled: primaryDisabled,
            }}
            secondaryAction={{
                label: "Cancel",
                icon: "times",
                tone: "destructiveSolid",
                onClick: onClose,
            }}
        />
    );
}

export default ConfirmationModal;
